export default __webpack_public_path__ + "static/media/youtube-light.54dda818.svg";